import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "adalcrea_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ "x-admin-token": getToken() });

// Resolve relative uploaded image paths (/api/files/...) to absolute URLs
export const imgUrl = (src) => (src && src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src);

// --- Upload ---
export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/upload`, fd, { headers: authHeaders() });
  return data.url;
};

// --- References ---
export const fetchReferences = async (featured) => {
  const params = featured ? { featured: true } : {};
  const { data } = await axios.get(`${API}/references`, { params });
  return data;
};

export const fetchReference = async (slug) => {
  const { data } = await axios.get(`${API}/references/${slug}`);
  return data;
};

export const reorderReferences = async (ids) => {
  const { data } = await axios.put(`${API}/references/reorder`, { ids }, { headers: authHeaders() });
  return data;
};

export const patchReference = async (id, fields) => {
  const { data } = await axios.patch(`${API}/references/${id}`, fields, { headers: authHeaders() });
  return data;
};

export const createReference = async (payload) => {
  const { data } = await axios.post(`${API}/references`, payload, { headers: authHeaders() });
  return data;
};

export const updateReference = async (id, payload) => {
  const { data } = await axios.put(`${API}/references/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deleteReference = async (id) => {
  const { data } = await axios.delete(`${API}/references/${id}`, { headers: authHeaders() });
  return data;
};

// --- Public blog ---
export const fetchPosts = async (category) => {
  const params = category && category !== "all" ? { category } : {};
  const { data } = await axios.get(`${API}/blog/posts`, { params });
  return data;
};

export const fetchPost = async (slug) => {
  const { data } = await axios.get(`${API}/blog/posts/${slug}`);
  return data;
};

// --- Admin ---
export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data.token;
};

export const createPost = async (payload) => {
  const { data } = await axios.post(`${API}/blog/posts`, payload, { headers: authHeaders() });
  return data;
};

export const updatePost = async (id, payload) => {
  const { data } = await axios.put(`${API}/blog/posts/${id}`, payload, { headers: authHeaders() });
  return data;
};

export const deletePost = async (id) => {
  const { data } = await axios.delete(`${API}/blog/posts/${id}`, { headers: authHeaders() });
  return data;
};

// --- Contact ---
export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

// --- Admin inbox ---
export const fetchContacts = async (status) => {
  const params = status && status !== "all" ? { status } : {};
  const { data } = await axios.get(`${API}/contacts`, { params, headers: authHeaders() });
  return data;
};

export const fetchContactStats = async () => {
  const { data } = await axios.get(`${API}/contacts/stats`, { headers: authHeaders() });
  return data;
};

export const patchContact = async (id, fields) => {
  const { data } = await axios.patch(`${API}/contacts/${id}`, fields, { headers: authHeaders() });
  return data;
};

export const deleteContact = async (id) => {
  const { data } = await axios.delete(`${API}/contacts/${id}`, { headers: authHeaders() });
  return data;
};

// Blog content helpers: legacy plain text (paragraphs by blank line) vs HTML from rich editor
export const isHtmlContent = (s) => /^\s*</.test(s || "");
export const resolveHtmlImages = (html) => (html || "").replace(/src="\/api\/files\//g, `src="${BACKEND_URL}/api/files/`);
